import { TFunction } from 'i18next'

import { ProductType } from '@features/products/enums/productType'

export const getProductTypeLabel = (value: string, t: TFunction): string => {
  return value.toLowerCase() === ProductType.Goods.toLowerCase()
    ? t('sales_report.sales_by_item.table.column.item_type.goods')
    : t('sales_report.sales_by_item.table.column.item_type.service')
}
